import axios from "axios";

interface ApiResponse {
  data: any[];
  status: string;
}

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/api_server"
    : "https://www.ppkm.org.my/api_server";

const getCMSAudits = async () => {
try {
    const { data } = await axios.get<ApiResponse>(
    `${API_BASE_URL}/get_cms_audits/`
    );
    return data;
} catch (error) {
    return error;
}
};

const getMobileAudits = async () => {
  try {
      const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_mobile_audits/`
      );
      return data;
  } catch (error) {
      return error;
  }
  };

  const getWebAudits = async () => {
    try {
        const { data } = await axios.get<ApiResponse>(
        `${API_BASE_URL}/get_web_audits/`
        );
        return data;
    } catch (error) {
        return error;
    }
    };


const api = {
  getCMSAudits,
  getMobileAudits,
  getWebAudits
};

export default api;
